import api from "api";
import { queryKeys } from "queries";
import { useQuery } from "react-query";
import { IUser } from "types/user";

const useQueryUser = ({ filterCallback }: { filterCallback?: (queriedUsers: IUser[]) => IUser[] }) => {
	const query = useQuery([queryKeys.USER, "all"], () => (filterCallback ? api.user.get().then(filterCallback) : api.user.get()), {
		refetchOnWindowFocus: false,
	});
	return query;
};

export default useQueryUser;
